export const updateGeneralInfo = (payload) => ({
  //always caps
  type: "UPDATE",
  payload: payload,
});
